module.exports = __webpack_public_path__ + "img/partner.c601fe5c.jpg";